<template>
  <div class="my-12 md:my-16 lg:my-20">
    <ul v-if="type === 'inline'">
      <li v-for="img in row.files" :key="img.src" class="mb-12">
        <media-item :item="img" :block="blockCaption" @img-select="focus($event)"/>
      </li>

      <!-- block caption -->
      <figcaption v-if="blockCaption" v-html="blockCaption" class="max-w-6xl text-xs mt-2 mb-6 flex-1 mb-16"></figcaption>
    </ul>

    <div v-else-if="type === 'slideshow'" class="md:pr-10 relative">
      <ul class="my-8 lg:my-16 flex overflow-x-scroll scroll-snap-x -mx-4 md:-mx-12">
        <li v-for="img in row.files" :key="img.src" class="flex-none snap-center md-snap-start pl-4 md:pl-12">
          <figure v-if="isImg(img)" class="">
            <img :src="blank" :data-src="mdImg(img)" @click="focus(img.src)" class="slideshow-img lazyload" sizes="auto"/>
            <figcaption v-if="img.content && !blockCaption" v-html="img.content.caption" class="text-xs mt-2 flex-1 text-center md:text-left"></figcaption>
          </figure>
        </li>
        <li class="pl-4 md:pl-40"></li>
      </ul>
      <!-- <div class="absolute pointer-events-none w-12 top-0 right-0 h-full hidden md:block bg-shader -mr-2"></div> -->

      <!-- block caption -->
      <figcaption v-if="blockCaption" v-html="blockCaption" class="text-sm mt-2 mb-6"></figcaption>
    </div>

    <div v-else-if="type === 'grid'" class="my-8 lg:my-16">
      <div>
        <ul class="flex flex-wrap -mx-2">
          <li v-for="img in row.files" :key="img.src" @click="focus(img.src)" class="px-2 mb-4 w-1/2 lg:w-1/3 cursor-zoom-in">
            <base-bg-image :image="img"/>
          </li>
        </ul>
      </div>

      <!-- block caption -->
      <figcaption v-if="blockCaption" v-html="blockCaption" class="text-sm mt-2 mb-6"></figcaption>
    </div>
  </div>
</template>

<script>
import { mdImg, lgImg } from '@/utils'
import MediaItem from '@/components/MediaItem'

export default {
  name: 'BaseMediaRow',
  props: {
    row: {
      type: Object,
      required: true
    },
    location: String,
    details: String,
    credits: Array
  },
  data () {
    return {
      blank: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
      changingImg: false,
      lightboxVisible: false,
      lightboxIndex: 0
    }
  },
  computed: {
    type () {
      return this.row.display_type || 'inline'
    },
    imgCount () {
      return this.row.files.length
    },
    blockCaption () {
      const c = this.row.caption
      if (!c) return false
      return c.length > 0 && c
    }
  },
  methods: {
    mdImg,
    lgImg,

    showLightbox (i) {
      this.lightboxIndex = i
      this.lightboxVisible = true
    },
    isImg (item) {
      return item.mime.includes('image')
    },
    maxWidth (img) {
      return { maxWidth: `${img.dimensions.width}px` }
    },
    width ({ dimensions }) {
      return dimensions.width
    },
    height ({ dimensions }) {
      return dimensions.height
    },
    imgReady () {
      this.$nextTick(() => {
        this.changingImg = false
      })
    },
    focus (img = null) {
      if (window.matchMedia('@media (hover: none)')) {
        this.$emit('img-select', img)
      }
    }
  },
  components: { MediaItem }
}
</script>
